module.exports = __webpack_public_path__ + "static/bbc-radio-4d5f196ec267a56d1f8685f38b614c3d.svg";